import React, { useEffect } from 'react'
import { Col, Container, Row } from 'react-bootstrap';
import { Route, useLocation } from 'react-router-dom';
import BlogCard from '../../components/BlogCard';
import SectionHeader from '../../components/SectionHeader';
import Button from '../../components/Button';

function Blog() {
    useEffect(()=>{
        document.title = "Your Page Title";
    },[])

    return (
        <div>
            <div className="sectionWrapper">
                <Container>
                    <Row className="align-items-center">
                        <Col sm={7}>
                            <SectionHeader className="">

                                <h2 className="title">
                                    Ohter <span>Blogs</span>
                                </h2>
                            </SectionHeader>
                        </Col>
                        <Col sm={5} className="d-flex justify-content-end">
                            <Button className="border-button  btncomponent">Blogs</Button>
                        </Col>
                    </Row>
                    <div className="mt-3">
                        <></>
                    </div>
                </Container>
            </div>
        </div>
    )
}

export default Blog